// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VeeValidate from "vee-validate";
import ko from "vee-validate/dist/locale/ko.js";
import Element from "element-ui";
import "babel-polyfill";
import "es6-promise/auto";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/ko"; // element-ui 한글패치
require("./assets/css/normalize.css");
require("./assets/css/font-awesome.min.css");
require("./assets/css/themify-icons.css");
require("./assets/css/flag-icon.min.css");
require("./assets/css/cs-skin-elastic.css");
require("./assets/scss/style.css");
require("es6-promise").polyfill();
import VueClipboard from "vue-clipboard2";
import * as filters from "../src/utils/rocket-code";

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Element, { locale, size: "small", zIndex: 3000 });
Vue.use(router);
// validate ko 설정
const validConfig = {
  locale: "ko",
  fieldsBagName: "veeFields",
  dictionary: {
    ko
  }
};
Vue.use(VeeValidate, validConfig);

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// validate custom
const dictionary = {
  ko: {
    messages: {
      alpha: () => `문자형식만 가능합니다. `,
      required: () => "필수항목 입니다."
    },
    attributes: {
      loginId: "아이디",
      passwd: "비밀번호",
      groupCode: "그룹코드",
      loginPasswd: "비밀번호"
    }
  }
};

VeeValidate.Validator.localize(dictionary);

Vue.prototype.$EventBus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js